import { mergeClasses } from '@griffel/react';

const UIIconBtn = ({ id, btnKey, className, iconClass, onClick, showNotification = false }) => {
	className = mergeClasses('icon-btn', id, className);

	return (
		<button className={className} id={id} data-key={btnKey} onClick={() => onClick(btnKey)}>
			<p className={`icon ${iconClass}`} />
			{showNotification && (
				<div className="notification-badge" />
			)}
		</button>
	);
};

export default UIIconBtn;